// Reutilizamos el nuevo dashboard genérico para que los cambios se reflejen
// también en las vistas de superadministrador sin duplicar lógica.
import React from 'react';
import Dashboard from './Dashboard';

const SuperAdminDashboard = () => {
    return <Dashboard />;
};

export default SuperAdminDashboard;